module.exports = __webpack_public_path__ + "img/SES_8293L.f35d8aab.jpg";